var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner"},_vm._l((3),function(n){return _c('div',{key:n,class:`ball bounce${n}`,style:({ backgroundColor: _vm.color })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }